import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  SelectChangeEvent,
  Radio,
} from '@mui/material';
import './MultiSelectDropdown.scss';

interface MultiSelectDropdownProps {
  id: string;
  label: string;
  options: string[];
  selectedValues: string[];
  onChange: (event: SelectChangeEvent<string[]>) => void;
}

interface RadioSelectDropdownProps {
  id: string;
  label: string;
  options: string[];
  selectedValue: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

const MultiSelectDropdown = ({
  id,
  label,
  options,
  selectedValues,
  onChange,
}:MultiSelectDropdownProps) => {
  const sortedOptions = (options || []).includes("All")
    ? [
        "All",
        ...(options || [])
          .filter((o) => o !== "All")
          .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }))
      ]
    : [...(options || [])].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
  return (
    <FormControl size="small" className="form-control-container__text-field">
      <Select
        id={`${id}-select`}
        multiple
        value={selectedValues}
        onChange={onChange}
        input={<OutlinedInput id={id}/>}
        renderValue={(selected) =>
          (selected as string[]).includes("All") ? "All" : (selected as string[]).join(', ')
        }
      >
        {sortedOptions.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={selectedValues.indexOf(name) > -1} />
            <ListItemText
              slotProps={{
                primary: { sx: { fontSize: 12 } }
              }}
             primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const RadioSelectDropdown = ({
  id,
  label,
  options,
  selectedValue,
  onChange,
}:RadioSelectDropdownProps) => {
  return (
    <FormControl size="small" className="form-control-container__text-field">
      <Select
        id={`${id}-select`}
        value={selectedValue}
        onChange={onChange}
        input={<OutlinedInput id={id} />}
        renderValue={(selected) => selected as string}
        displayEmpty
      >
        {options.map((name) => (
          <MenuItem key={name} value={name}>
            <Radio checked={selectedValue === name} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelectDropdown;
export { RadioSelectDropdown };

